var _rect, _ellipse, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCups(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 520",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Hot and cold drink cups") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 520,
    fill: "#eaf0f4"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 405,
    cy: 430,
    rx: 235,
    ry: 30,
    fill: "#162d45",
    opacity: 0.12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M170 150h235l-28 260H205z",
    fill: "#fff",
    stroke: "#162d45",
    strokeWidth: 14
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M155 150h265",
    stroke: "#c49356",
    strokeWidth: 22,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M460 170h175l-24 240H484z",
    fill: "#b9dbea",
    fillOpacity: 0.65,
    stroke: "#162d45",
    strokeWidth: 14
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M445 170h205",
    stroke: "#c49356",
    strokeWidth: 20,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M570 55l-32 250",
    stroke: "#162d45",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M236 235h110",
    stroke: "#c49356",
    strokeWidth: 16,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCups);
export default __webpack_public_path__ + "static/media/cups.5aa39d32df6e836615d96e460748c572.svg";
export { ForwardRef as ReactComponent };